function updateCartCount() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            const cartCount = data.item_count;
            const cartCountElement = document.querySelector('.header__cart-count');
            if (cartCountElement) {
                cartCountElement.textContent = cartCount;
                cartCountElement.style.visibility = 'visible';
            }
        })
        .catch(console.error);
}

function handleCartAction() {
    setTimeout(updateCartCount, 500);
}

const actions = [
    '.cart__remove-button',
    '.supercart-close-header',
    '.text-blue-700.border-b.border-blue-700.pb-px.no-underline',
    '.super_qty',
    '.product-form__add-button.button.button--primary',
    '.supercart-lines'
];

document.addEventListener('click', (event) => {
    if (actions.some(selector => event.target.matches(selector) || event.target.closest(selector))) {
        handleCartAction();
    }
});

document.querySelectorAll('.product-form__add-button.button.button--primary, .super_qty, .supercart-lines').forEach(button => {
    button.addEventListener('click', handleCartAction);
});

document.addEventListener('DOMContentLoaded', updateCartCount);
